const PROJECT_ID = '4506121843048448';

export {PROJECT_ID};
